import DTO from './DTO';

class ReportTemplateDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'id',
      },
      {
        name: 'data',
        type: String,
        validators: {},
        labelKey: 'check.types.data',
      },
      {
        name: 'service',
        type: String,
        validators: {},
        labelKey: 'check.types.service',
      },
      {
        name: 'source',
        type: String,
        validators: {},
        labelKey: 'check.types.source',
      },
      {
        name: 'created_at',
        type: String,
        validators: {},
        labelKey: 'check.types.created_at',
      },
      {
        name: 'status',
        type: String,
        validators: {},
        labelKey: 'check.types.status',
      },
      {
        name: 'procedures',
        type: String,
        validators: {},
        labelKey: 'check.types.apply_to_procedures',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default ReportTemplateDTO;
